export enum userActionTypes {
  CURRENT_USER_LOADING = 'CURRENT_USER_LOADING',
  SET_CURRENT_USER = 'CURRENT_USER',
  SET_USER_METADATA = 'SET_USER_METADATA',
  CURRENT_USER_FAILURE = 'CURRENT_USER_FAILURE',
  SET_USERS = 'SET_USERS',
  SET_USERS_FILTERS = 'SET_USERS_FILTERS',
  USERS_LOADING = 'USERS_LOADING',
  USERS_FAILURE = 'USERS_FAILURE',
  SET_USERS_TOTAL = 'SET_USERS_TOTAL',
}
